import type { SVGProps } from 'react';

export const DarkMode = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.025 20.5q-3.55 0-6.025-2.475T3.525 12q0-2.95 1.825-5.25 1.85-2.325 4.9-2.975.3-.075.525.025.25.075.4.275a.78.78 0 0 1 .175.45.77.77 0 0 1-.1.525 4.7 4.7 0 0 0-.475 1.175q-.15.6-.15 1.275 0 2.45 1.725 4.175t4.175 1.725q.75 0 1.4-.175.675-.2 1.175-.45a1 1 0 0 1 .475-.075.87.87 0 0 1 .425.15q.175.125.25.35.1.225.025.5-.525 2.95-2.875 4.875-2.325 1.925-5.375 1.925m0-1.5q2.2 0 3.95-1.2a7.1 7.1 0 0 0 2.55-3.175q-.5.125-1 .2t-1 .075q-3.075 0-5.25-2.15-2.15-2.175-2.15-5.25 0-.5.075-1t.2-1a7.1 7.1 0 0 0-3.175 2.55q-1.2 1.75-1.2 3.95 0 2.9 2.05 4.95t4.95 2.05" />
    </svg>
  );
};
